import { extendServiceContainer } from '@iotize/tap';
import { ScramService } from './service';

declare module '@iotize/tap/lib/service-container' {
  interface ServiceContainer {
    scram: ScramService;
  }
}

export const _TAP_SERVICE_EXTENSION_SCRAM_ = extendServiceContainer(
  'scram',
  ScramService,
);
